module.exports = __webpack_public_path__ + "static/media/chevron-down.dffb9e48.svg";